import axios from 'axios';

import { GetSamplePointDto } from 'types/dto/sample-point.dto';
import { AssetTypeCode, RawAssetTypeCode } from 'types/models/asset-type';
import { APIResponseParsed } from 'types/response';
import { getRequest } from 'utils/HttpRequest/http-request-utils';

import { parseAxiosError } from './utils/parse-axios-error';

// ==============================
// REQUESTS
// ==============================
async function fetchCameraSamplePoints(): Promise<APIResponseParsed<GetSamplePointDto[]>> {
  try {
    const response = await getRequest<GetSamplePointDto[]>(
      '/samplepoint',
      {
        params: {
          fields: ['deviceId'],
          s: {
            $and: [
              {
                statusActive: { $eq: 1 }
              },
              {
                assetTypeId: { $eq: AssetTypeCode.CAMERA }
              }
            ]
          }
        }
      }
    );
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

async function fetchSamplePointsByDeviceId(
  deviceId: number
): Promise<APIResponseParsed<GetSamplePointDto[]>> {
  try {
    const response = await getRequest<GetSamplePointDto[]>(
      '/samplepoint?join=device&join=site',
      {
        params: {
          fields: ['deviceId'],
          s: {
            $and: [
              {
                deviceId: { $eq: deviceId }
              },
              {
                statusActive: { $eq: 1 }
              },
              {
                assetTypeId: {
                  $notin: [
                    RawAssetTypeCode.UNKNOWN,
                    RawAssetTypeCode.HEATER_SENSOR,
                    RawAssetTypeCode.INTERNAL_SENSOR,
                    RawAssetTypeCode.SECURITY_CAMERA
                  ]
                }
              }
            ]
          }
        }
      }
    );
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

export default {
  fetchCameraSamplePoints,
  fetchSamplePointsByDeviceId
};
